import React from 'react';
import PageSection from '../../components/PageSection';
import DataTable from '../../components/DataTable';
import RawJsonDisplay from '../../components/RawJsonDisplay';
import { WorkspaceInfo } from 'types';
import { OrgContextLink, useOrgContext } from 'components/OrgContextProvider';

interface WorkspacesListContainerProps {
	workspaces: WorkspaceInfo[];
	onChanged: () => void;
}

const WorkspacesListContainer = ({ workspaces, onChanged }: WorkspacesListContainerProps) => {
	const ctx = useOrgContext();

	const deleteWorkspace = (workspace: WorkspaceInfo) => {
		if (window.confirm(`Delete workspace "${workspace.name}"?`)) {
			fetch(`${ctx?.apiBaseTenant}/workspaces/${workspace.id}`, { method: 'DELETE' })
			.then(() => onChanged());
		}
	};

	return (
		<div>
			<PageSection title="Workspaces" level={1}>
				<DataTable<WorkspaceInfo>
					data={workspaces}
					columns={[
						{ label: 'Name', key: 'name', render: (ws) => <OrgContextLink level="tenant" to={`/settings/workspaces/${ws.id}`}>{ws.name}</OrgContextLink> },
						{ label: 'ID', key: 'id' }
					]}
					tools={[
						{ label: 'Delete', action: (ws) => deleteWorkspace(ws) }
					]}
					tableTools={[
						{ label: 'Create New Workspace...', render: () => <OrgContextLink level="tenant" to="/settings/workspaces/new">Create New Workspace...</OrgContextLink> }
					]}
				/>
			</PageSection>

			<PageSection title="Raw Data" level={2}>
				<RawJsonDisplay data={workspaces} />
			</PageSection>
		</div>
	);
};

export default WorkspacesListContainer;
